import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { FcProgressSpinnerComponent } from './fc-progress-spinner.component';

const components = [FcProgressSpinnerComponent];

@NgModule({
    declarations: components,
    imports: [CommonModule, MatProgressSpinnerModule],
    exports: components
})
export class FcProgressSpinnerModule {}
